import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "service-tile-available",
  templateUrl: "service-tile-available.html",
  styleUrls: ["./service-tile-available.scss", "../service-tile/service-tile.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class ServiceTileAvailableComponent {
  protected serviceUrl = input.required<string>();
  protected serviceTitle = input.required<string>();
  protected serviceIcon = input.required<string>();
  protected serviceBody = input.required<string>();
  protected forceColor = input(false);
  protected actionButtonText = input("Global.MoreInfo");
}
